import { useQuery } from '@tanstack/react-query';
import calendarEventApiClient, {
  CalendarEvent,
} from '../../../api/calendarEvent';

const useCalendarEventQuery = (calendarEventId: string) => {
  return useQuery<CalendarEvent | undefined>({
    queryKey: ['calendarEvent', calendarEventId],
    queryFn: async () => {
      return calendarEventApiClient.getCalendarEvent(calendarEventId);
    },
    enabled: !!calendarEventId,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export default useCalendarEventQuery;
